import { CCPAButton } from './ccpa-button.component';

export { CCPAButton };
